import decode from 'jwt-decode';

var hasAuth = (request) => {
    if((localStorage.getItem('token') !== null) && decode(localStorage.getItem('token')).exp > Date.now() / 1000) {
        return request();
    } else {
        localStorage.clear();
        window.location.replace("/");
    }
};

export default { hasAuth };